export const ROOTS_CALCULATOR = '/';
export const ROOTS_SAVINGS = '/savings';